import { render, staticRenderFns } from "./SubApprovalModal.vue?vue&type=template&id=0047af87"
import script from "./SubApprovalModal.vue?vue&type=script&lang=js"
export * from "./SubApprovalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports